/* eslint-disable */
import Api from '@/repository/index'

/**
 * state начальное состояние модуля видимости разделов
 * @type {{isLoading: boolean, featuresVisibility: [{name: string, isVisible: boolean, featureId: string}]}}
 */
const state = {
  featuresVisibility: [],
  isLoading: false
}

const mutations = {
  SET_FEATURES_VISIBILITY (state, featuresVisibility) {
    state.featuresVisibility = featuresVisibility
  },

  UPDATE_FEATURES_VISIBILITY (state, featuresVisibilityDto) {
    state.featuresVisibility = state.featuresVisibility.map(feature => {
      if (feature.featureId !== featuresVisibilityDto.featureId) return feature
      return {
        ...feature,
        isVisible: featuresVisibilityDto.isVisible
      }
    })
  },

  SET_IS_LOADING (state, isLoading) {
    state.isLoading = isLoading
  }
}

const actions = {
  async fetchFeaturesVisibility ({ commit }) {
    try {
      commit('SET_IS_LOADING', true)
      const response = await Api.featuresVisibilityRepository.getFeaturesVisibility()
      commit('SET_FEATURES_VISIBILITY', response)
      return response
    } catch (err) {
      return Promise.reject(err)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },
  async updateFeatureVisibility ({ commit }, featureVisibilityDto) {
    try {
      commit('SET_IS_LOADING', true)
      await Api.featuresVisibilityRepository.updateFeaturesVisibility(featureVisibilityDto)
      commit('UPDATE_FEATURES_VISIBILITY', featureVisibilityDto)
    } catch (err) {
      return Promise.reject(err)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
